// extracted by mini-css-extract-plugin
export var job_desc_all = "career-module--job_desc_all--2KYNB";
export var headline_for_job = "career-module--headline_for_job--1RRu6";
export var headline_for_jobs = "career-module--headline_for_jobs--1fegW";
export var links_text = "career-module--links_text--32yMJ";
export var links_for_candidates = "career-module--links_for_candidates--PrEyU";
export var offerts = "career-module--offerts--1TOxD";
export var draw_line_work = "career-module--draw_line_work--2THUS";
export var work_description = "career-module--work_description--2XFqS";
export var formulage = "career-module--formulage--3FgAe";
export var work__form = "career-module--work__form--3Eurt";
export var work__email = "career-module--work__email--DFTVz";
export var challenge = "career-module--challenge--1SSF0";
export var box_curriculum = "career-module--box_curriculum--1z-tr";
export var work_box = "career-module--work_box--2jZNj";
export var p = "career-module--p--2Pdr3";